import InputLabel from "./InputLabel";
import Select from "./InputLabelSelect";
import CheckBox from "./InputLabelCheckBox";

export const InputLabelSelect = Select;
export const InputLabelCheckBox = CheckBox;

export default InputLabel;
